jQuery(document).ready(function($){
  $('div.no_of_items span.value').text($('input.quantity-input__input').val()*$('input.quantity-input__input').parents('.quantity-input-wrapper').siblings('.no_of_items').find('input[name="items_per_case"]').val());
  $('input.quantity-input__input').change(function(){
    $('div.no_of_items span.value').text($(this).val()*$(this).parents('.quantity-input-wrapper').siblings('.no_of_items').find('input[name="items_per_case"]').val());
  });
  $('input.quantity-input__input').keyup(function(){
    $('div.no_of_items span.value').text($(this).val()*$(this).parents('.quantity-input-wrapper').siblings('.no_of_items').find('input[name="items_per_case"]').val());
  });
  
  $('.cart__form-item').each(function(){
    $(this).find('span.value').text($(this).find('input.quantity-input__input').val()*$(this).find('input[name="items_per_case"]').val());
  });
  
  // View Only Mode - Security and UI Enhancement
  // This prevents client-side form submission attempts during view-only mode
  // Note: Server-side validation is the primary security mechanism
  
  var isViewOnlyMode = $('[data-view-only-banner]').length > 0 ||
                       $('[data-view-only-mode="true"]').length > 0 ||
                       $('button[data-view-only-mode="true"]').length > 0;
  
  if (isViewOnlyMode) {
    console.log('View Only Mode is active - purchasing disabled');
    
    // Prevent all product form submissions
    $('form[action*="/cart/add"]').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      alert('Purchasing is temporarily unavailable. The store is currently in view-only mode.');
      return false;
    });
    
    // Prevent add to cart via AJAX
    $(document).on('click', '[data-add-to-cart]', function(e) {
      var button = $(this);
      var form = button.closest('form[action*="/cart/add"]');
      
      if (form.length > 0) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    });
    
    // Prevent checkout form submissions
    $('button[name="checkout"]').on('click', function(e) {
      if ($(this).is('[disabled]')) {
        e.preventDefault();
        e.stopPropagation();
        alert('Checkout is temporarily unavailable. The store is currently in view-only mode.');
        return false;
      }
    });
    
    // Intercept any fetch/XHR requests to cart endpoints
    var originalFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      
      // Block requests to cart add/update endpoints
      if (typeof url === 'string' && (
          url.includes('/cart/add') ||
          url.includes('/cart/update') ||
          url.includes('/checkout')
        )) {
        console.warn('Blocked cart operation in view-only mode:', url);
        return Promise.reject(new Error('Store is in view-only mode'));
      }
      
      return originalFetch.apply(this, arguments);
    };
    
    // Disable quick add buttons if they exist
    $('[data-quick-add-button]').prop('disabled', true).addClass('disabled');
    
    // Disable any Buy Now buttons
    $('.shopify-payment-button button').prop('disabled', true).addClass('disabled');
    
    // Add visual feedback to disabled buttons
    $('button[disabled][data-add-to-cart], button[name="checkout"][disabled]').css({
      'pointer-events': 'none',
      'opacity': '0.6'
    });
  }
  
});